import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'genesis-frontend-recommendation-card-title',
    templateUrl: './recommendation-card-title.component.html',
    styleUrls: ['./recommendation-card-title.component.scss']
})
export class RecommendationCardTitleComponent {
    @Input() @HostBinding('attr.id') id = '';
    @Input() headingLevel: 3 | 4 = 3;

    @HostBinding('class') class = 'recommendation-card-title flex h4 break-word m-none';
    @HostBinding('attr.role') role = 'heading';
    @HostBinding('attr.aria-level')
    get ariaLevel() {
        return this.headingLevel;
    }
}
